import { produce } from 'immer';
import { SIDE_BET_ANIMATION_SET } from '../../animations/animationDefinitions';
import { ADD_SIDE_BET, CLEAR_SIDE_BETS_STATE, DISABLE_MY_SIDE_BET_CONTROLS, HIDE_SIDE_BET_ANIMATION, SET_IS_SELECTING_TARGET, SET_SIDE_BETS_HAND_RESULT } from '../actions/sideBetsActions';
const initialState = {
    sideBetItems: [],
    sideBetJacksPotTotal: 0,
    sideBetAnimations: {},
    sideBetsHandResult: {
        type: 'pending'
    }
};
function draftClearExpiredSideBetAnimations(draft, nowMs) {
    if (!draft.sideBetAnimations) {
        return;
    }
    nowMs = nowMs || performance.now();
    // add a short "grace period" to ensure the animation finishes rendering:
    const expiredAnimationTimestampMs = nowMs - SIDE_BET_ANIMATION_SET.totalDurationMs - 500;
    Object.entries(draft.sideBetAnimations).forEach(([seatIndex, { startTimestampMs }]) => {
        if (startTimestampMs < expiredAnimationTimestampMs) {
            delete draft.sideBetAnimations[seatIndex];
        }
    });
}
const sideBetsReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_SIDE_BETS_STATE: {
                return initialState;
            }
            case ADD_SIDE_BET: {
                const { bettorPlayer, targetPlayer, targetSeatIndex, sideBetJacksPotTotal, isMyPlacedSideBet } = action.payload;
                draft.sideBetItems.push({
                    targetPlayer,
                    bettorPlayer
                });
                draft.sideBetJacksPotTotal = sideBetJacksPotTotal;
                // start animation:
                const nowMs = performance.now();
                draft.sideBetAnimations[targetSeatIndex] = {
                    startTimestampMs: nowMs,
                    bettorPlayerName: bettorPlayer.name
                };
                draftClearExpiredSideBetAnimations(draft, nowMs);
                if (isMyPlacedSideBet) {
                    draft.myPlacedSideBetTargetPlayerId = targetPlayer.id;
                }
                break;
            }
            case DISABLE_MY_SIDE_BET_CONTROLS: {
                draft.areMySideBetControlsDisabled = true;
                break;
            }
            case HIDE_SIDE_BET_ANIMATION: {
                const seatIndex = action.payload;
                delete draft.sideBetAnimations[seatIndex];
                draftClearExpiredSideBetAnimations(draft);
                break;
            }
            case SET_IS_SELECTING_TARGET: {
                const isSelectingSideBetTarget = action.payload;
                if (isSelectingSideBetTarget) {
                    draft.selectSideBetTargetStartTimestampMs = performance.now();
                }
                else {
                    delete draft.selectSideBetTargetStartTimestampMs;
                }
                break;
            }
            case SET_SIDE_BETS_HAND_RESULT: {
                draft.sideBetsHandResult = action.payload;
                break;
            }
        }
    });
};
export default sideBetsReducer;
